module.exports = __webpack_public_path__ + "img/logo_sq_bg.6843022d.svg";